import React from 'react'
import './unauthorized.scss'
import unauthorized from '../../assets/images/unauthorized.png'
import { Card } from '@softwaredev_cegeka/stix-core/dist/components'

class Unauthorized extends React.Component {
    render() {
        return (
            <Card>
                <Card.Header>
                    <Card.Title className={'unauthorized-title'}>
                        You are not authorized to access this data.
                    </Card.Title>
                </Card.Header>

                <img
                    src={unauthorized}
                    className={'unauthorized-image'}
                    alt={''}
                />
            </Card>
        )
    }
}

export default Unauthorized
